
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"transparent","d":"M0 0h20v20H0z"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"8","fill":"#E3F7DD"}}),_c('circle',{attrs:{"cx":"10","cy":"10","r":"7","stroke":"#107C41","stroke-width":"2"}}),_c('path',{attrs:{"d":"M6.469 10.138l2.447 2.647L14 8","stroke":"#107C41","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    